<template>
  <div class="water-mark-wrap">
    <span class="water-word" v-for="(item, index) in 40" :key="index">
      {{ userInfo.organizationName }} {{ userInfo.name }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'water-mark',
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
}
</script>
<style lang="less" scoped>
// 样式编写区
.water-mark-wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 99;
  pointer-events: none;
  top: 0;
  left: 0;
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
}
.water-word {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: rgba(8, 8, 8, 0.05);
  transform: rotate(-45deg);
  user-select: none;
}
</style>
